import React, { useEffect, useState } from "react";
import ServiceCard from "../../components/card/ServiceCard";
import PageBanner from "../../components/PageBanner";
import ServiceService from "../../services/service";
import BannerService from "../../services/banner";
import { useParams } from "react-router-dom";

export default function Service() {
  let [serviceData, setServiceData] = useState([]);
  let [serviceBanner, setServiceBanner] = useState([]);

  let { lang } = useParams();

  //return lang function
  useEffect(() => {
    if (lang !== "th" && lang !== "en") {
      window.open(`/th`, "_self");
    }
  });

  useEffect(() => {
    window.scrollTo(0, 0);
    getServiceData();
    getServiceBanner();
  }, []);

  const getServiceData = async () => {
    try {
      let res = await ServiceService.getService();
      setServiceData(res);
    } catch {
      console.error();
    }
  };

  const getServiceBanner = async () => {
    try {
      let res = await BannerService.getBanner(1);
      setServiceBanner(res);
    } catch {
      console.error();
    }
  };

  const bannerText = [{ name: "service", href: "/service" }];

  return (
    <div id="service" className="pt-[135px] lg:pt-[0px]">
      <PageBanner
        text_th={"บริการ"}
        text_en={"Service"}
        banner={serviceBanner?.banner}
        bannerText={bannerText}
        lang={lang}
      />

      <div className="section">
        <div className="page-container">
          {/* บริการ */}
          <div className="mt-[92px] mb-[300px]">
            <h1 className="text-heading font-bold text-slateGray text-left">
              {lang === "th" ? "บริการ" : "Service"}
            </h1>

            <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-[24px] mt-[25px]">
              {serviceData &&
                serviceData.map((service, i) => (
                  <ServiceCard
                    image={service.image ? service.image : ""}
                    name={
                      lang === "th"
                        ? service.link.label_TH
                        : service.link.label_EN
                    }
                    linkTo={`/${lang}/service${service.link.href}`}
                    key={i}
                    lang={lang}
                  />
                ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
